export default __webpack_public_path__ + "51b8481fc94de404b55707ad412fb014.ttf";